import { Link } from "react-router-dom";
import { ArrowRight, GraduationCap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface LearnCalloutProps {
  className?: string;
  title?: string;
}

/** Compact entry point into the Learning Hub (landing + dashboard). */
export const LearnCallout = ({ className, title = "Build your AI skills" }: LearnCalloutProps) => (
  <aside
    aria-label="Learning Hub"
    className={cn(
      "flex flex-col gap-4 rounded-2xl border border-primary/30 bg-card/60 p-5 sm:flex-row sm:items-center sm:justify-between",
      className,
    )}
  >
    <div className="flex items-start gap-3">
      <div className="rounded-xl bg-primary/10 p-2 text-primary">
        <GraduationCap className="h-6 w-6" aria-hidden />
      </div>
      <div>
        <p className="font-semibold text-foreground">{title}</p>
        <p className="text-sm text-muted-foreground">
          Learn with AI Kenny — AI safety, prompting, cybersecurity and AI fluency in one place.
        </p>
      </div>
    </div>
    <Button asChild className="shrink-0 focus-ring">
      <Link to="/learn">
        Open the Learning Hub
        <ArrowRight className="ml-2 h-4 w-4" aria-hidden />
      </Link>
    </Button>
  </aside>
);

export default LearnCallout;
